import i18n from "@/i18n.ts";
import { ApiIdTitle } from "@/types/common.types.ts";

export enum ApiWorkflowConditionFieldType {
  string = "string",
  integer = "integer",
  decimal = "decimal",
  boolean = "boolean",
  date = "date",
  datetime = "datetime",

  array_integer = "array_integer",
  array_string = "array_string",
}

export enum ApiWorkflowConditionEntityTypes {
  employee = "employee",
  event = "event",
  time_off = "time_off",
  candidate = "candidate",
  job = "job",
}

export const getApiWorkflowConditionEntityTypesTitle = (
  type: ApiWorkflowConditionEntityTypes
): string => {
  switch (type) {
    case ApiWorkflowConditionEntityTypes.employee:
      return i18n.t("workflow:condition_entity_type_employee");
    case ApiWorkflowConditionEntityTypes.event:
      return i18n.t("workflow:condition_entity_type_event");
    case ApiWorkflowConditionEntityTypes.time_off:
      return i18n.t("workflow:condition_entity_type_time_off");
    case ApiWorkflowConditionEntityTypes.candidate:
      return i18n.t("ats:candidate");
    case ApiWorkflowConditionEntityTypes.job:
      return i18n.t("ats:job");
  }
};

export enum ApiWorkflowConditionFieldTypes {
  // employee_first_name = "employee_first_name",

  employee_position_department_id = "employee_position_department_id",
  employee_position_division_id = "employee_position_division_id",
  employee_employment_legal_entity_id = "employee_employment_legal_entity_id",
  employee_position_location_id = "employee_position_location_id",
  employee_position_job_profile_id = "employee_position_job_profile_id",

  // event_type = "event_type",

  time_off_category_id = "time_off_category_id",

  candidate_stage_id = "candidate_stage_id",
  candidate_previous_stage_id = "candidate_previous_stage_id",
  candidate_pipeline_id = "candidate_pipeline_id",
  candidate_disqualification_reason_id = "candidate_disqualification_reason_id",

  job_id = "job_id",
  job_department_id = "job_department_id",
  job_division_id = "job_division_id",
  job_location_id = "job_location_id",
}

export const getApiWorkflowConditionFieldTypesTitle = (
  type: ApiWorkflowConditionFieldTypes
): string => {
  switch (type) {
    case ApiWorkflowConditionFieldTypes.employee_position_department_id:
      return i18n.t("core:department");
    case ApiWorkflowConditionFieldTypes.employee_position_division_id:
      return i18n.t("core:division");
    case ApiWorkflowConditionFieldTypes.employee_employment_legal_entity_id:
      return i18n.t("core:legal_entity");
    case ApiWorkflowConditionFieldTypes.employee_position_location_id:
      return i18n.t("common:location");
    case ApiWorkflowConditionFieldTypes.employee_position_job_profile_id:
      return i18n.t("core:job_profile");
    case ApiWorkflowConditionFieldTypes.time_off_category_id:
      return i18n.t("time_off:category");
    case ApiWorkflowConditionFieldTypes.candidate_stage_id:
      return i18n.t("ats:stage");
    case ApiWorkflowConditionFieldTypes.candidate_previous_stage_id:
      return i18n.t("workflow:condition_field_candidate_previous_stage");
    case ApiWorkflowConditionFieldTypes.candidate_pipeline_id:
      return i18n.t("ats:pipeline");
    case ApiWorkflowConditionFieldTypes.candidate_disqualification_reason_id:
      return i18n.t("ats:disqualification_reason");
    case ApiWorkflowConditionFieldTypes.job_id:
      return i18n.t("ats:job");
    case ApiWorkflowConditionFieldTypes.job_department_id:
      return i18n.t("core:department");
    case ApiWorkflowConditionFieldTypes.job_division_id:
      return i18n.t("core:division");
    case ApiWorkflowConditionFieldTypes.job_location_id:
      return i18n.t("common:location");
  }
};

export enum ApiWorkflowConditionOperator {
  equals = "equals",
  not_equals = "not_equals",
  greater_than = "greater_than",
  greater_than_or_equal = "greater_than_or_equal",
  less_than = "less_than",
  less_than_or_equal = "less_than_or_equal",

  contains = "contains",
  not_contains = "not_contains",
  starts_with = "starts_with",
  ends_with = "ends_with",

  in_ = "in",
  not_in = "not_in",

  is_null = "is_null",
  is_not_null = "is_not_null",
}

type ApiWorkflowScalarValue = string | number | boolean | null;
type ApiWorkflowArrayValue = number[] | string[] | null;
export type ApiWorkflowConditionFieldValue = ApiWorkflowScalarValue | ApiWorkflowArrayValue;

export interface ApiWorkflowConditionField {
  type: ApiWorkflowConditionFieldType;
  value: ApiWorkflowConditionFieldValue;
}

export interface ApiWorkflowCondition {
  id: number;
  entity_type: ApiWorkflowConditionEntityTypes;
  field_name: ApiWorkflowConditionFieldTypes;
  operator: ApiWorkflowConditionOperator;
  field_value: ApiWorkflowConditionField;
  condition_group: number;
  condition_entities: ApiIdTitle[];
}

export interface ApiWorkflowConditionSave {
  entity_type: ApiWorkflowConditionEntityTypes;
  field_name: ApiWorkflowConditionFieldTypes;
  operator: ApiWorkflowConditionOperator;
  field_value: ApiWorkflowConditionField;
  condition_group: number;
}
